import React, { useEffect, useRef, useState } from 'react';

interface MinuteRunnerProps {
    onMinute: () => void;
}

export function MinuteRunner({ onMinute }: MinuteRunnerProps) {
    useEffect(() => {
        const intervalId = window.setInterval(() => {
            onMinute();
            console.log('MinuteRunner tick');
        }, 30_000);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [onMinute]);

    return null;
}